import {VideoStateMgrGen} from "./ms-state-controller-gen";
import {VideoStateMgrIos} from "./ms-state-controller-ios";

export class VideoStateMgr {

  static createManager(autoplay, restMS, displayErrorPanel, restartPlayer) {
    let isIOS = [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(navigator.platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
    let canPlay = document.createElement('video').canPlayType('application/vnd.apple.mpegURL');
    console.log('-->', isIOS, canPlay);
    // Can for Ipad and Iphone
    if (isIOS && canPlay) {
      console.log('load IOS state mgr');
      return new VideoStateMgrIos(autoplay, restMS, displayErrorPanel, restartPlayer);
    }
    // Generic manager state for all.
    console.log('load standard state mgr');
    return new VideoStateMgrGen(autoplay, restMS, displayErrorPanel, restartPlayer);
  }
}
